import React from 'react';
import { Link } from 'react-router-dom';
import { useBlog } from '../components/BlogContext';
import { Helmet } from 'react-helmet-async';
import './Blog.css';

const Blog = () => {
  const { getPublishedPosts } = useBlog();
  const publishedPosts = getPublishedPosts();

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const truncateContent = (content, maxLength = 200) => {
    // Remove HTML tags and truncate
    const textContent = content.replace(/<[^>]*>/g, '');
    if (textContent.length <= maxLength) return textContent;
    return textContent.substr(0, maxLength) + '...';
  };

  return (
    <>
    <Helmet defer={false}>
      <title>Car Wash Blog - Tips and News from Quick Way UAE</title>
      <meta name="description" content="Latest car care tips, mobile car wash news, and eco-friendly cleaning advice from Quick Way in UAE." />
      {/* Posts are stored in each visitor's browser (localStorage), not on a server, so the blog is kept out of search results until it has a real CMS. */}
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <nav className="breadcrumbs">
      <div className="container">
        <Link to="/">Home</Link>
        <span className="separator">&gt;</span>
        <span className="current">Blog</span>
      </div>
    </nav>
    <div className="blog-page">
      <div className="container">
        <header className="blog-header">
          <h1>Quick Way Blog</h1>
          <p className="blog-subtitle">
            Stay updated with the latest tips, news, and insights about mobile car wash services in UAE
          </p>
        </header>

        <div className="blog-grid">
          {publishedPosts.length === 0 ? (
            <div className="no-posts">
              <h3>No blog posts yet</h3>
              <p>Check back soon for the latest updates!</p>
            </div>
          ) : (
            publishedPosts.map(post => (
              <article key={post.id} className="blog-card">
                {post.featuredImage && (
                  <div className="blog-card-image">
                    <img
                      src={post.featuredImage}
                      alt={post.title}
                      onError={(e) => {
                        e.target.src = '/logo.png'; // Fallback to logo if image fails
                      }}
                    />
                  </div>
                )}

                <div className="blog-card-content">
                  <h2 className="blog-card-title">
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h2>

                  <div className="blog-card-meta">
                    <time dateTime={post.createdAt}>
                      {formatDate(post.createdAt)}
                    </time>
                  </div>

                  <p className="blog-card-excerpt">
                    {truncateContent(post.content)}
                  </p>

                  <Link to={`/blog/${post.slug}`} className="read-more-link">
                    Read More →
                  </Link>
                </div>
              </article>
            ))
          )}
        </div>
      </div>
    </div>
    </>
  );
};

export default Blog;
